import { useEffect, useState } from "react";
import { ProtectedRoutes } from "./protect_router";
import { Routes, Route } from "react-router-dom"
import { useDrawerContext } from "../shered/contexts/DrawerContext";
import { Dashboard } from "../pages";
import { ListagemDeUsuarios } from "../pages/usuarios/ListagemDeUsuarios";
import { DetalheDeUsuarios } from "../pages/usuarios/DetalheDeUsuarios"

import { ListagemDeLigas } from "../pages/ligas/ListagemDeLigas";
import { DetalheDeLigas } from "../pages/ligas/DetalheDeLiga";
import { Inicio } from "../shered/components";
import { Liga } from "../pages/ligas/Liga";
import { ListagemDeMinhaFranquia } from "../pages/franquia/ListagemDeMinhaFranquia";
import { DetalheDeFranquia } from "../pages/franquia/DetalheDeFranquia";
import { DetalheDeDisputa } from "../pages/disputa/DetalheDeDisputa";
import { ListagemDeDisputa } from "../pages/disputa/ListagemDeDisputa";
import CookieService from "../shered/services/autenticacao/CookieService";
import { ListagemDraftPicks } from "../pages/draft/ListagemDraftPicks";
import { ListagemDraftSalarios } from "../pages/draft/ListagemDraftSalarios";
import { DetalheDeDraftEscolhas } from "../pages/draft/DetalheDeDraftEscolhas";
import { ListagemDeFreeAgency } from "../pages/freeagency/ListagemDeFreeAgency";
import { ListagemDeCalendario } from "../pages/calendario/ListagemDeCalendario";
import { DetalheDeEscalacao } from "../pages/escalacao/DetalheDeEscalacao";
import { Drafts } from "../pages/draft/Drafts";
import { ListagemDeJogadores } from "../pages/jogadores/ListagemDeJogadores";
import { DetalheDeJogadores } from "../pages/jogadores/DetalheDeJogadores";
import { DetalheDePropostas } from "../pages/propostas/DetalheDePropostas";
import { ListagemDeFranquias } from "../pages/franquia/ListagemDeFranquias";
import { ListagemDePropostas } from "../pages/propostas/ListagemDePropostas";
import { ListagemDeClassificacao } from "../pages/classificacao/ListagemDeClassificacao";
import { ListagemDeLigasAdm } from "../pages/ligas/ListagemDeLigasAdm";
import { IDadosBlog, UtilidadeService } from "../shered/services/api/utilidades/UtilidadesService";
import { ListagemDeHistorico } from "../pages/historico/ListagemDeHistorico";
import { DetalheDeLeilao } from "../pages/leilao/DetalheDeLeilao";
import { DetalhesDadosDeFreeAgency } from "../pages/freeagency/DetalheDadosDeFreeAgency";
import { ListagemDeFinanceiro } from "../pages/financeiro/ListagemDeFinanceiro";
import { ListagemDeListao } from "../pages/listao/ListagemDeListao";
import { ListagemDeMeusJogadores } from "../pages/estatisticas/ListagemDeMeusJogadores";
import { ListagemDeMediaJogadores } from "../pages/estatisticas/ListagemDeMediaJogadores";
import { ListagemDeHistoricoConfrontos } from "../pages/estatisticas/ListagemDeHistoricoConfrontos";
import { ListagemDeMediaTimes } from "../pages/estatisticas/ListagemDeMediaTimes";
import { ListagemDeFranquiaVersus } from "../pages/estatisticas/ListagemDeFranquiaVersus";
import { ListagemDeCalendarioPlayOffs } from "../pages/calendarioPlayOffs/ListagemDeCalendarioPlayOffs";
import { DetalheDeEscalacaoPlayOffs } from "../pages/escalacao/DetalheDeEscalacaoPlayOffs";
import { ListagemDeDisputaPlayOffs } from "../pages/disputa/ListagemDeDisputaPlayOffs";
import { ListagemDeBlogs } from "../pages/blog/ListagemDeBlog";
import { ListagemDeJogadoresDisponiveis } from "../pages/jogadores/ListagemDeJogadoresDisponiveis";
import { ListagemDeTrofeusLiga } from "../pages/estatisticas/ListagemDeTrofeusLiga";
import { ListagemDeTroufeusGM } from "../pages/estatisticas/ListagemDeTrofeusGM";
import { DetalheDeGaleriaGM } from "../pages/estatisticas/DetalheDeGaleriaGM";
import { ListagemDePowerRanking } from "../pages/estatisticas/ListagemDePowerRanking";
import { DetalheDeConfigMensagem } from "../pages/configuracoes/DetalheDeConfigMensagem";
import { ListagemDeMapaCalor } from "../pages/estatisticas/ListagemDeMapaCalor";
import { ListagemDeClassificacaoHistorica } from "../pages/estatisticas/ListagemDeClassificacaoHistorica";
import { ListagemDeMovimentacoes } from "../pages/movimentacoes/ListagemDeMovimentacoes";
import { ListagemDeJogadoresLideres } from "../pages/estatisticas/ListagemDeJogadoresLideres";
import { ListagemDeFranquiasLideres } from "../pages/estatisticas/ListagemDeFranquiasLideres";
import { ListagemDeFranquiaVersusPorRodada } from "../pages/estatisticas/ListagemDeFranquiaVersusPorRodada";
import { DetalheDeEscalacaoPontuacao } from "../pages/escalacao/DetalheDeEscalacaoPontuacao";
import { ListagemDeDisputaPontuacao } from "../pages/disputa/ListagemDeDisputaPontuacao";
import { DetalheDeEscalacaoPlayOffsPontuacao } from "../pages/escalacao/DetalheDeEscalacaoPlayOffsPontuacao ";
import { ListagemDeDisputaPontuacaoPlayOffs } from "../pages/disputa/ListagemDeDisputaPontuacaoPlayOffs";
import { ListagemDeComparacaoJogadores } from "../pages/estatisticas/ListagemDeComparacaoJogadores";
import { DetalheDePropostassimples } from "../pages/propostas/DetalheDePropostasSimples";
import { ListagemDeLesionados } from "../pages/jogadores/ListagemDeLesionados";
import { ListagemDeCalendarioFranquia } from "../pages/calendario/ListagemDeCalendarioFranquia";
import { ListagemDePicks } from "../pages/picks/ListagemDePicks";
import { ListagemDePodcasts } from "../pages/podcast/ListagemDePodCast";
import { DetalheDePropostasHistoricos } from "../pages/propostas/DetalheDePropostasHistorico";
import { DetalheDeDispensaHistorico } from "../pages/jogadores/DetalheDeDispensaHistorico";
import { ListagemDeCopinha } from "../pages/calendario/ListagemDeCopinha";
import { ListagemDeJogadoresFavoritos } from "../pages/jogadores/ListagemDeJogadoresFavoritos";
import { ListagemDeMelhoresJogadores } from "../pages/estatisticas/ListagemDeMelhoresJogadores";
import { DetalheDeConfigComissario } from "../pages/configuracoes/DetalheDeConfigComissario";
import { ListagemDeRecordes } from "../pages/estatisticas/ListagemDeRecodes";
import { ListagemDeCalendarioPlayOffsCopinha } from "../pages/calendarioPlayOffs/ListagemDeCalendarioPlayOffsCopinha";
import { ListagemDeLigasPorUsuario } from "../pages/relatorios/ListagemDeLigasPorUsuario";
import { ListagemDeJogos } from "../pages/aposta/ListagemDeJogos";
import { ListagemDeMinhasApostas } from "../pages/aposta/ListagemDeMinhasApostas";
import { ListagemDeClassificacaoAposta } from "../pages/aposta/ListagemDeClassificacaoAposta";
import { FinanceiroService } from "../shered/services/api/financeiro/FinanceiroService";
import { ListagemDeClassificacoesNBA } from "../pages/estatisticas/ListagemDeClassificacoesNBA";
import Maintenance from "../shered/components/manuntencao/Manuntencao";
import { ListagemDeRelPagamentoPendente } from "../pages/relatorios/ListagemDeRelPagamentoPendente";
import { ListagemDeHistoricoFinanceiroUsuarios } from "../pages/relatorios/ListagemDeHistoricoFinanceiroUsuarios";
import { ListagemDeReceitasPorTemporada } from "../pages/relatorios/ListagemDeReceitasPorTemporada";

export const Routering = () => {
    const { setDrawerOptions } = useDrawerContext();
    const user = CookieService.get("access_user");
    const comissario = user.comissario;
    const adm = user.administrador;
    const dado = UtilidadeService.crypt(user.codUsuario.toString());
    const crypt = UtilidadeService.crypt("0");
    const cryptCalendario = UtilidadeService.crypt("-1");
    const codLiga = localStorage.getItem("@codigoLiga");
    const cryptFavorito = codLiga !== undefined ? codLiga?.toString() : UtilidadeService.crypt(user.codigo_Liga_Favorito);
    const [dadosPodCast, setDadosPodCast] = useState<IDadosBlog>();
    const [atualizar, setAtualizar] = useState(false);
    const [usuarioInadiplente, setUsuarioInadiplente] = useState(true);
    let urlPodCast = "";
    //maior valor menu 76 
    useEffect(() => {
        const fetchData = async () => {
            await UtilidadeService.getUrlBlogAtual(1)
                .then((result) => {
                    setDadosPodCast(result.dado);
                    urlPodCast = result.dado.url;
                    setAtualizar(true);
                })
                .catch((errors) => {
                    console.log(errors);
                });
            if (!user.administrador) {
                let temporadaAtual = 0;
                await UtilidadeService.getTemporadaAtual()
                    .then((result) => {
                        temporadaAtual = result.dado.codigo;
                    })
                    .catch((errors) => {
                        console.log(errors);
                    });
                await FinanceiroService.getUsuarioInadimplente(Number(user.codUsuario), Number(temporadaAtual))
                    .then((result) => {
                        setUsuarioInadiplente(result.dado);
                        setAtualizar(true);
                    })
                    .catch((errors) => {
                        console.log(errors);
                    });
            }
            else {
                setUsuarioInadiplente(false);
            }
        }
        fetchData();

        setDrawerOptions([
            {
                codigo: 1,
                icon: "home",
                path: "/dashboard",
                label: "Página inicial",
                visible: true,
                subMenu: []
            },
            {
                codigo: 2,
                icon: "admin_panel_settings",
                label: "Administrador",
                path: "",
                visible: adm,
                subMenu: [
                    {
                        codigo: 3,
                        icon: "person",
                        path: "/adm/usuarios",
                        label: "Usuários",
                        visible: true,
                        subMenu: []
                    }, {
                        codigo: 4,
                        icon: "sports_basketball",
                        path: "/adm/ligas",
                        label: "Ligas",
                        visible: true,
                        subMenu: []
                    }, {
                        codigo: 61,
                        icon: "history_edu",
                        path: `/adm/proposta/historico/detalhe/nova`,
                        label: "Proposta Histórico",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 62,
                        icon: "person_add_disabled",
                        path: `/adm/jogador/dispensa/historico/detalhe/nova`,
                        label: "Dispensa Histórico",
                        visible: true,
                        subMenu: []
                    },
                    // {
                    //     codigo: 63,
                    //     icon: "playlist_add_check_circle",
                    //     path: `/adm/jogador/cadastro/franquia/detalhe/nova`,
                    //     label: "Jogador Por Franquia",
                    //     visible: false,
                    //     subMenu: []
                    // }
                ]
            },
            {
                codigo: 5,
                icon: "api",
                label: "Liga",
                path: "",
                visible: user.pagamentoConcluido ? true : false,
                subMenu: [
                    {
                        codigo: 6,
                        icon: "feed",
                        path: `/usuario/liga/${cryptFavorito}`,
                        label: "Notícias",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 30,
                        icon: "groups2",
                        path: `/usuario/franquia/detalhe/${crypt}`,
                        label: "Meu Time",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 7,
                        icon: "format_list_numbered",
                        path: "/liga/classificacao",
                        label: "Classificação",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 8,
                        icon: "calendar_month",
                        path: "",
                        label: "Calendário",
                        visible: true,
                        subMenu: [
                            {
                                codigo: 58,
                                icon: "calendar_view_day",
                                path: `/liga/calendario/${cryptCalendario}`,
                                label: "Rodadas",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 57,
                                icon: "event_note",
                                path: `/liga/franquia/calendario/${cryptCalendario}`,
                                label: "Franquia",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 64,
                                icon: "emoji_events",
                                path: `/liga/copinha/calendario/${cryptCalendario}`,
                                label: "Copinha",
                                visible: true,
                                subMenu: []
                            },
                        ]
                    },
                    {
                        codigo: 40,
                        icon: "date_range",
                        path: "",
                        label: "Play IN/OFF",
                        visible: true,
                        subMenu: [
                            {
                                codigo: 68,
                                icon: "cropSquare",
                                path: `/liga/playoffs/${crypt}`,
                                label: "Normal",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 69,
                                icon: "copyright",
                                path: `/liga/playoffs/copinha/${crypt}`,
                                label: "Copinha",
                                visible: true,
                                subMenu: []
                            }
                        ]
                    },
                    {
                        codigo: 9,
                        icon: "note_alt",
                        path: "",
                        label: "Proposta",
                        visible: true,
                        subMenu: [
                            {
                                codigo: 51,
                                icon: "checklist",
                                path: "/liga/propostas/completa",
                                label: "Completa",
                                visible: true,
                                subMenu: []
                            }, {
                                codigo: 52,
                                icon: "check",
                                path: `/liga/propostas/simples`,
                                label: "Simples",
                                visible: true,
                                subMenu: []
                            }
                        ]
                    },
                    {
                        codigo: 10,
                        icon: "security",
                        path: "/liga/franquias",
                        label: "Franquias",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: []
                    },
                    {
                        codigo: 11,
                        icon: "add_task",
                        path: "",
                        label: "Free Agency",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: [
                            {
                                codigo: 27,
                                icon: "monetization_on",
                                path: "/liga/freeagency/detalhe",
                                label: "Lance",
                                visible: true,
                                subMenu: []
                            }, {
                                codigo: 28,
                                icon: "dataset",
                                path: `/liga/freeagency/detalhes/dados/${crypt}`,
                                label: "Dados FA",
                                visible: true,
                                subMenu: []
                            }
                        ]
                    },
                    {
                        codigo: 12,
                        icon: "summarize",
                        path: "",
                        label: "Drafts",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: [
                            {
                                codigo: 53,
                                icon: "drafts",
                                path: "/liga/draft/escolha",
                                label: "Draft",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 54,
                                icon: "checklistRtl",
                                path: "/liga/draft/preferencia",
                                label: "Preferências",
                                visible: true,
                                subMenu: []
                            }
                        ]
                    },
                    // {
                    //     codigo: 13,
                    //     icon: "monetization_on_icon",
                    //     path: "/liga/draft/salarios/detalhe",
                    //     label: "Draft Salários",
                    //     subMenu: []
                    // },
                    // {
                    //     codigo: 14,
                    //     icon: "checklist_rtl",
                    //     path: "/liga/draft/escolhas/detalhe",
                    //     label: "Draft Escolhas",
                    //     subMenu: []
                    // },
                    {
                        codigo: 15,
                        icon: "settings_suggest",
                        path: "/liga/disputa/detalhe",
                        label: "Configurações",
                        visible: true,
                        subMenu: []

                    },
                    {
                        codigo: 16,
                        icon: "people",
                        path: "/liga/jogadores",
                        label: "Jogadores",
                        visible: true,
                        subMenu: [
                            {
                                codigo: 55,
                                icon: "people",
                                path: "/liga/jogador/todos",
                                label: "Todos",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 39,
                                icon: "people_outline",
                                path: "/liga/jogador/disponiveis",
                                label: "Disponível",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 56,
                                icon: "local_hospital",
                                path: "/liga/jogador/lesionados",
                                label: "Lesionados",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 65,
                                icon: "star_border_purple500",
                                path: "/liga/jogador/favorito",
                                label: "Favoritos",
                                visible: true,
                                subMenu: []
                            },
                        ]
                    },

                    {
                        codigo: 25,
                        icon: "gavel",
                        path: "/liga/leilao/detalhe",
                        label: "Leilão",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 26,
                        icon: "history",
                        path: "/liga/historico",
                        label: "Histórico Drafts",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 31,
                        icon: "list",
                        path: "/liga/listao",
                        label: "Listão",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 32,
                        icon: "bar_chart",
                        path: "",
                        label: "Estatísticas",
                        visible: true,
                        subMenu: [
                            {
                                codigo: 34,
                                icon: "equalizer",
                                path: "/liga/estatisticas/mediatimes",
                                label: "Média Times",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 35,
                                icon: "show_chart",
                                path: "/liga/estatisticas/mediajogadores",
                                label: "Média Jogadores",
                                visible: true,
                                subMenu: []
                            }, {
                                codigo: 36,
                                icon: "signal_cellular_alt",
                                path: "/liga/estatisticas/franquiaversus",
                                label: "Franquia X",
                                visible: true,
                                subMenu: []
                            }, {
                                codigo: 37,
                                icon: "timeline",
                                path: "/liga/estatisticas/historicoconfrontos",
                                label: "Histórico Confrontos",
                                visible: true,
                                subMenu: []
                            }, {
                                codigo: 38,
                                icon: "assignment_ind",
                                path: "/liga/estatisticas/mediameusjogadores",
                                label: "Meus Jogadores",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 41,
                                icon: "emoji_events",
                                path: "/liga/estatisticas/trofeusgm",
                                label: "Troféu GM",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 42,
                                icon: "workspace_premium",
                                path: `/liga/estatisticas/trofeusliga`,
                                label: "Troféu Liga",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 43,
                                icon: "bolt",
                                path: `/liga/estatisticas/powerranking`,
                                label: "Power Ranking",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 45,
                                icon: "whatshot",
                                path: `/liga/estatisticas/mapacalor`,
                                label: "Sequência de Jogos",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 46,
                                icon: "format_list_numbered",
                                path: `/liga/estatisticas/classificacaohistorica`,
                                label: "Classificação Histórica",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 47,
                                icon: "insights",
                                path: `/liga/estatisticas/jogadoreslideres`,
                                label: "Líderes por Temporada",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 48,
                                icon: "trending_up",
                                path: `/liga/estatisticas/franquiaslideres`,
                                label: "Franquias Líderes",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 49,
                                icon: "compare_arrows",
                                path: `/liga/estatisticas/franquiaversusrodada`,
                                label: "Franquias Por Rodada",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 50,
                                icon: "compare",
                                path: `/liga/estatisticas/comparacaojogadores`,
                                label: "Comparar Jogador",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 66,
                                icon: "star_border_purple_500",
                                path: `/liga/estatisticas/melhoresjogadores`,
                                label: "Melhor Jogador",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 63,
                                icon: "gpp_good",
                                path: `/liga/estatisticas/recordes`,
                                label: "Recordes",
                                visible: true,
                                subMenu: []
                            },
                            {
                                codigo: 76,
                                icon: "list_alt",
                                path: `/liga/estatisticas/classificacoesnba`,
                                label: "Classificações NBA",
                                visible: true,
                                subMenu: []
                            },
                        ]
                    },
                    {
                        codigo: 17,
                        icon: "change_circle",
                        path: `/liga/movimentacoes`,
                        label: "Movimentações",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 59,
                        icon: "token",
                        path: "/liga/picks",
                        label: "Picks",
                        visible: true,
                        subMenu: []
                    },
                ]
            },
            {
                codigo: 18,
                icon: "person",
                label: "Usuário",
                path: "",
                visible: true,
                subMenu: [
                    {
                        codigo: 19,
                        icon: "account_circle",
                        path: `/usuario/usuarios/detalhe/${dado}`,
                        label: "Meu Usuário",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 20,
                        icon: "list_alt",
                        path: "/usuario/ligas",
                        label: "Minhas Ligas",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: []
                    },
                    {
                        codigo: 21,
                        icon: "security",
                        path: "/usuario/minhafranquia",
                        label: "Minhas Franquias",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: []
                    },
                    // {
                    //     codigo: 22,
                    //     icon: "insert_invitation",
                    //     path: "usuario/conviteligas",
                    //     label: "Convite Ligas",
                    //     subMenu: []
                    // },
                    {
                        codigo: 23,
                        icon: "note_add",
                        path: "/usuario/liga/detalhe/nova",
                        label: "Criar Liga",
                        visible: user.pagamentoConcluido ? true : false,
                        subMenu: []
                    },
                    // {
                    //     codigo: 20,
                    //     icon: "emoji_events",
                    //     path: `/usuario/disputa/detalhe`,
                    //     label: "Disputas",
                    //     subMenu: []
                    // },
                    {
                        codigo: 29,
                        icon: "monetization_on",
                        path: `/usuario/financeiro/${UtilidadeService.crypt((0).toString())}`,
                        label: "Financeiro",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 44,
                        icon: "message",
                        path: `/usuario/configuracao/mensagem/detalhe`,
                        label: "Config. Mensagem",
                        visible: true,
                        subMenu: []
                    },
                    {
                        codigo: 67,
                        icon: "accessibility",
                        path: `/usuario/comissario/detalhe`,
                        label: "Comissários",
                        visible: true,
                        subMenu: []
                    }
                ]
            },
            {
                codigo: 60,
                icon: "podcasts",
                path: "/podcastsmudfaz",
                label: "Podcast MudFaz",
                visible: true,
                target: "_blank",
                href: dadosPodCast?.url !== null ? dadosPodCast?.url : urlPodCast, //"https://youtu.be/1T95JmnVubI?si=J9H_6mVcv2C3EifR",
                subMenu: []
            },
            {
                codigo: 70,
                icon: "auto_awesome_mosaic",
                label: "Relatório",
                path: "",
                visible: adm,
                subMenu: [
                    {
                        codigo: 71,
                        icon: "local_atm",
                        path: `/relatorio/pagamentopendente/${dado}`,
                        label: "Pagamento Pendente",
                        visible: user.administrador,
                        subMenu: []
                    },
                     {
                        codigo: 77,
                        icon: "admin_panel_settings",
                        path: `/relatorio/ligasusuario/${dado}`,
                        label: "Ligas Usuário",
                        visible: user.administrador,
                        subMenu: []
                    },
                    {
                        codigo: 78,
                        icon: "calculate",
                        path: `/relatorio/financeiro/historico/usuario/${dado}`,
                        label: "Financeiro Usuários",
                        visible: user.administrador,
                        subMenu: []
                    },
                    {
                        codigo: 79,
                        icon: "local_atm",
                        path: `/relatorio/receitastemporada/${dado}`,
                        label: "Receitas por Temporada",
                        visible: user.administrador,
                        subMenu: []
                    },
                ]
            },
            {
                codigo: 72,
                icon: "games",
                label: "Apostas",
                path: "",
                visible: false, //!usuarioInadiplente, // user.pagamentoConcluido || user.administrador ? true : false,
                subMenu: [
                    {
                        codigo: 73,
                        icon: "casino",
                        path: `/aposta/listagemjogos/${dado}`,
                        label: "Jogos",
                        visible: user.pagamentoConcluido || user.administrador ? true : false,
                        subMenu: []
                    },
                    {
                        codigo: 74,
                        icon: "create",
                        path: `/aposta/listagemminhasapostas/${dado}`,
                        label: "Minhas Apostas",
                        visible: user.pagamentoConcluido || user.administrador ? true : false,
                        subMenu: []
                    },
                    {
                        codigo: 75,
                        icon: "format_list_numbered",
                        path: `/aposta/classificacao/${dado}`,
                        label: "Classificação",
                        visible: false, // user.pagamentoConcluido || user.administrador ? true : false,
                        subMenu: []
                    },
                ]
            },
        ])
    }, [atualizar]);


    return (
        <Routes>
            <Route path="/manuntencao" element={<Maintenance estimatedTime=" Junho de 2026" />} />
            <Route path="/login" element={<Inicio visivel={true} />} />
            <Route path="/" element={<Inicio visivel={true} />} />
            <Route path="/dashboard" element={<ProtectedRoutes><Dashboard /></ProtectedRoutes>} />
            <Route path="/podcastsparceiros" element={<ProtectedRoutes><ListagemDeBlogs /></ProtectedRoutes>} />
            <Route path="/podcastsmudfaz" element={<ProtectedRoutes><ListagemDePodcasts /></ProtectedRoutes>} />

            <Route path="/adm/usuarios" element={<ProtectedRoutes><ListagemDeUsuarios /></ProtectedRoutes>} />
            <Route path="/adm/usuarios/detalhe/:id" element={<ProtectedRoutes><DetalheDeUsuarios /></ProtectedRoutes>} />
            <Route path="/adm/ligas" element={<ProtectedRoutes><ListagemDeLigasAdm /></ProtectedRoutes>} />
            <Route path="/adm/proposta/historico/detalhe/:id" element={<ProtectedRoutes><DetalheDePropostasHistoricos /></ProtectedRoutes>} />
            <Route path="/adm/jogador/dispensa/historico/detalhe/:id" element={<ProtectedRoutes><DetalheDeDispensaHistorico /></ProtectedRoutes>} />

            <Route path="/liga/freeagency/detalhe" element={<ProtectedRoutes><ListagemDeFreeAgency /></ProtectedRoutes>} />
            <Route path="/liga/freeagency/detalhes/dados/:id" element={<ProtectedRoutes><DetalhesDadosDeFreeAgency /></ProtectedRoutes>} />

            <Route path="/liga/draft/escolha" element={<ProtectedRoutes><Drafts /></ProtectedRoutes>} />
            <Route path="/liga/draft/picks/detalhe" element={<ProtectedRoutes><ListagemDraftPicks /></ProtectedRoutes>} />
            <Route path="/liga/draft/salarios/detalhe" element={<ProtectedRoutes><ListagemDraftSalarios /></ProtectedRoutes>} />
            <Route path="/liga/draft/preferencia" element={<ProtectedRoutes><DetalheDeDraftEscolhas /></ProtectedRoutes>} />
            <Route path="/liga/calendario/:id" element={<ProtectedRoutes><ListagemDeCalendario /></ProtectedRoutes>} />
            <Route path="/liga/franquia/calendario/:id" element={<ProtectedRoutes><ListagemDeCalendarioFranquia /></ProtectedRoutes>} />
            <Route path="/liga/copinha/calendario/:id" element={<ProtectedRoutes><ListagemDeCopinha /></ProtectedRoutes>} />

            <Route path="/liga/playoffs/:id" element={<ProtectedRoutes><ListagemDeCalendarioPlayOffs /></ProtectedRoutes>} />
            <Route path="/liga/playoffs/copinha/:id" element={<ProtectedRoutes><ListagemDeCalendarioPlayOffsCopinha /></ProtectedRoutes>} />
            <Route path="/liga/propostas/completa" element={<ProtectedRoutes><ListagemDePropostas /></ProtectedRoutes>} />
            <Route path="/liga/propostas/simples" element={<ProtectedRoutes><DetalheDePropostassimples /></ProtectedRoutes>} />
            <Route path="/liga/proposta/detalhe/:id" element={<ProtectedRoutes><DetalheDePropostas /></ProtectedRoutes>} />
            <Route path="/liga/franquias" element={<ProtectedRoutes><ListagemDeFranquias /></ProtectedRoutes>} />
            <Route path="/liga/classificacao" element={<ProtectedRoutes><ListagemDeClassificacao /></ProtectedRoutes>} />
            <Route path="/liga/jogador/todos" element={<ProtectedRoutes><ListagemDeJogadores /></ProtectedRoutes>} />
            <Route path="/liga/jogador/disponiveis" element={<ProtectedRoutes><ListagemDeJogadoresDisponiveis /></ProtectedRoutes>} />
            <Route path="/liga/jogador/favorito" element={<ProtectedRoutes><ListagemDeJogadoresFavoritos /></ProtectedRoutes>} />
            <Route path="/liga/jogador/lesionados" element={<ProtectedRoutes><ListagemDeLesionados /></ProtectedRoutes>} />
            <Route path="/liga/jogadores/detalhe/:id" element={<ProtectedRoutes><DetalheDeJogadores /></ProtectedRoutes>} />
            <Route path="/liga/disputas/:id" element={<ProtectedRoutes><ListagemDeDisputa /></ProtectedRoutes>} />
            <Route path="/liga/disputas/pontuacao/:id" element={<ProtectedRoutes><ListagemDeDisputaPontuacao /></ProtectedRoutes>} />
            <Route path="/liga/disputa/detalhe" element={<ProtectedRoutes><DetalheDeDisputa /></ProtectedRoutes>} />
            <Route path="/liga/historico" element={<ProtectedRoutes><ListagemDeHistorico /></ProtectedRoutes>} />
            <Route path="/liga/leilao/detalhe" element={<ProtectedRoutes><DetalheDeLeilao /></ProtectedRoutes>} />
            <Route path="/liga/listao" element={<ProtectedRoutes><ListagemDeListao /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/mediajogadores" element={<ProtectedRoutes><ListagemDeMediaJogadores /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/mediameusjogadores" element={<ProtectedRoutes><ListagemDeMeusJogadores /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/historicoconfrontos" element={<ProtectedRoutes><ListagemDeHistoricoConfrontos /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/mediatimes" element={<ProtectedRoutes><ListagemDeMediaTimes /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/franquiaversus" element={<ProtectedRoutes><ListagemDeFranquiaVersus /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/mapacalor" element={<ProtectedRoutes><ListagemDeMapaCalor /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/comparacaojogadores" element={<ProtectedRoutes><ListagemDeComparacaoJogadores /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/melhoresjogadores" element={<ProtectedRoutes><ListagemDeMelhoresJogadores /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/powerranking" element={<ProtectedRoutes><ListagemDePowerRanking /></ProtectedRoutes>} />

            <Route path="/liga/estatisticas/trofeusgm" element={<ProtectedRoutes><ListagemDeTroufeusGM /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/galeria/detalhe/:id" element={<ProtectedRoutes><DetalheDeGaleriaGM /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/trofeusliga" element={<ProtectedRoutes><ListagemDeTrofeusLiga /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/classificacaohistorica" element={<ProtectedRoutes><ListagemDeClassificacaoHistorica /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/jogadoreslideres" element={<ProtectedRoutes><ListagemDeJogadoresLideres /></ProtectedRoutes>} />
            <Route path="/liga/movimentacoes" element={<ProtectedRoutes><ListagemDeMovimentacoes /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/franquiaslideres" element={<ProtectedRoutes><ListagemDeFranquiasLideres /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/franquiaversusrodada" element={<ProtectedRoutes><ListagemDeFranquiaVersusPorRodada /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/recordes" element={<ProtectedRoutes><ListagemDeRecordes /></ProtectedRoutes>} />
            <Route path="/liga/estatisticas/classificacoesnba" element={<ProtectedRoutes><ListagemDeClassificacoesNBA /></ProtectedRoutes>} />
            <Route path="/liga/picks" element={<ProtectedRoutes><ListagemDePicks /></ProtectedRoutes>} />

            <Route path="/usuario/ligas" element={<ProtectedRoutes><ListagemDeLigas /></ProtectedRoutes>} />
            <Route path="/usuario/liga/:id" element={<ProtectedRoutes><Liga /></ProtectedRoutes>} />
            <Route path="/usuario/liga" element={<ProtectedRoutes><Liga /></ProtectedRoutes>} />
            <Route path="/usuario/minhafranquia" element={<ProtectedRoutes><ListagemDeMinhaFranquia /></ProtectedRoutes>} />
            <Route path="/usuario/franquia/detalhe/:id" element={<ProtectedRoutes><DetalheDeFranquia /></ProtectedRoutes>} />
            <Route path="/usuario/liga/detalhe/:id" element={<ProtectedRoutes><DetalheDeLigas /></ProtectedRoutes>} />
            <Route path="/usuario/usuarios/detalhe/:id" element={<ProtectedRoutes><DetalheDeUsuarios /></ProtectedRoutes>} />
            <Route path="/usuario/financeiro/:id" element={<ProtectedRoutes><ListagemDeFinanceiro /></ProtectedRoutes>} />
            <Route path="/usuario/configuracao/mensagem/detalhe" element={<ProtectedRoutes><DetalheDeConfigMensagem /></ProtectedRoutes>} />
            <Route path="/usuario/comissario/detalhe" element={<ProtectedRoutes><DetalheDeConfigComissario /></ProtectedRoutes>} />

            <Route path="/relatorio/pagamentopendente/:id" element={<ProtectedRoutes><ListagemDeRelPagamentoPendente /></ProtectedRoutes>} />
            <Route path="/relatorio/ligasusuario/:id" element={<ProtectedRoutes><ListagemDeLigasPorUsuario /></ProtectedRoutes>} />
            <Route path="/relatorio/financeiro/historico/usuario/:id" element={<ProtectedRoutes><ListagemDeHistoricoFinanceiroUsuarios /></ProtectedRoutes>} />
            <Route path="/relatorio/receitastemporada/:id" element={<ProtectedRoutes><ListagemDeReceitasPorTemporada /></ProtectedRoutes>} />

            <Route path="/aposta/listagemjogos/:id" element={<ProtectedRoutes><ListagemDeJogos /></ProtectedRoutes>} />
            <Route path="/aposta/listagemminhasapostas/:id" element={<ProtectedRoutes><ListagemDeMinhasApostas /></ProtectedRoutes>} />
            <Route path="/aposta/classificacao/:id" element={<ProtectedRoutes><ListagemDeClassificacaoAposta /></ProtectedRoutes>} />


            <Route path="/escalacao/detalhe/:id" element={<ProtectedRoutes><DetalheDeEscalacao /></ProtectedRoutes>} />
            <Route path="/escalacao/pontuacao/detalhe/:id" element={<ProtectedRoutes><DetalheDeEscalacaoPontuacao /></ProtectedRoutes>} />
            <Route path="/escalacao/playoffs/detalhe/:id" element={<ProtectedRoutes><DetalheDeEscalacaoPlayOffs /></ProtectedRoutes>} />
            <Route path="/escalacao/pontuacao/playoffs/detalhe/:id" element={<ProtectedRoutes><DetalheDeEscalacaoPlayOffsPontuacao /></ProtectedRoutes>} />
            <Route path="/liga/disputas/playoffs/:id" element={<ProtectedRoutes><ListagemDeDisputaPlayOffs /></ProtectedRoutes>} />
            <Route path="/liga/disputas/pontuacao/playoffs/:id" element={<ProtectedRoutes><ListagemDeDisputaPontuacaoPlayOffs /></ProtectedRoutes>} />
            {/* <Route path="/escalacao/detalhe/:rodada/:jogo/:franquia/:minhafranquia" element={<ProtectedRoutes><DetalheDeEscalacao /></ProtectedRoutes>} /> */}
            <Route path="/configuracoes" element={<p>Configurações</p>} />
            <Route path="/configuracoes/detalhe/:id" element={<p>Dados configurações</p>} />
            {/* <Route path="/cidades/detalhe/:id" element={<ProtectedRoutes><DetalheDeCidades /></ProtectedRoutes>} /> */}
            {/* <Route path="/cidades" element={<ProtectedRoutes><ListagemDeCidades /></ProtectedRoutes>} /> */}
        </Routes >
    )
}